export default "__VITE_ASSET__CaV8Il2e__"